__webpack_require__.p = "/ashishportfolio/";